/**
 * AccountInformation Component
 * 
 * Handles the fourth and final step of the registration process, collecting
 * username and password information with password visibility toggles.
 * By default, uses the primary email as username with option for custom username.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.formData - Current form data state
 * @param {Function} props.handleChange - Function to handle form field changes
 * @param {boolean} props.showPassword - Whether to show password field in plain text
 * @param {Function} props.setShowPassword - Function to toggle password visibility
 * @param {boolean} props.showPasswordRetype - Whether to show password retype field in plain text
 * @param {Function} props.setShowPasswordRetype - Function to toggle password retype visibility
 * @param {boolean} props.useCustomUsername - Whether to use custom username instead of email
 * @param {Function} props.setUseCustomUsername - Function to toggle custom username option
 * @returns {JSX.Element} Account information form step
 */

import React from 'react';

const AccountInformation = ({ 
  formData, 
  handleChange, 
  showPassword, 
  setShowPassword, 
  showPasswordRetype, 
  setShowPasswordRetype
}) => {

  return (
    <div>
      <h4 className="mb-4">Personal Account Information</h4>

      <div className="mb-3">
        <label htmlFor="username" className="form-label">
          <i className="bi bi-person me-1"></i>
          Username <span className="text-danger">*</span>
        </label>
        
        <div>
          <input
            type="text"
            className="form-control"
            id="username"
            name="username"
            value={formData.primaryEmail}
            readOnly
            style={{ backgroundColor: '#f8f9fa' }}
          />
          <div className="form-text">
            Your primary email address is your username.
          </div>
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">
          <i className="bi bi-lock me-1"></i>
          Password <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            type={showPassword ? "text" : "password"}
            className="form-control"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <span className="input-group-text" style={{ cursor: 'pointer' }}>
            <i 
              className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
              style={{ fontSize: '1.1rem' }}
            ></i>
          </span>
        </div>
        <div className="form-text">
          Password should be at least 8 characters long.
        </div>
      </div>

      <div className="mb-3">
        <label htmlFor="passwordRetype" className="form-label">
          <i className="bi bi-lock-fill me-1"></i>
          Password Retype <span className="text-danger">*</span>
        </label>
        <div className="input-group">
          <input
            type={showPasswordRetype ? "text" : "password"}
            className="form-control"
            id="passwordRetype"
            name="passwordRetype"
            value={formData.passwordRetype}
            onChange={handleChange}
            required
          />
          <span className="input-group-text" style={{ cursor: 'pointer' }}>
            <i 
              className={`bi ${showPasswordRetype ? 'bi-eye-slash' : 'bi-eye'}`}
              onClick={() => setShowPasswordRetype(!showPasswordRetype)}
              aria-label={showPasswordRetype ? "Hide password" : "Show password"}
              style={{ fontSize: '1.1rem' }}
            ></i>
          </span>
        </div>
      </div>
    </div>
  );
};

export default AccountInformation;
